import { openBlock as e, createElementBlock as c, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(n, l) {
  return e(), c("svg", o, [...l[0] || (l[0] = [
    t("path", {
      fill: "currentColor",
      d: "M4.8 3.36c1.89 1.62 1.89 1.62 2.51 2.242l.422.422.435.44.46.461q.72.722 1.438 1.445l.983.986q1.197 1.2 2.392 2.404c-.326.73-.693 1.233-1.258 1.796l-.478.48-.515.51-.529.529q-.552.552-1.107 1.101-.852.846-1.7 1.696l-1.074 1.07-.517.515-.475.471-.42.418c-.327.294-.327.294-.567.294zM6 2.4c1.098.324 1.993.77 2.966 1.369l.429.262q.674.413 1.345.829l2.195 1.348Q14.74 7.318 16.56 8.4c-.184.869-.445 1.245-1.095 1.86l-.466.446-.359.334a5.6 5.6 0 0 1-1.774-1.232l-.466-.461-.494-.497-.512-.511q-.535-.534-1.068-1.07a449 449 0 0 0-1.643-1.64L7.646 4.59l-.5-.497-.456-.461-.405-.406C6 2.88 6 2.88 6 2.4m8.16 10.56c1.024.49 1.616 1.1 2.4 1.92-.353 1.106-1.25 1.483-2.205 2.01a439 439 0 0 0-1.703.97c-1.476.86-2.923 1.767-4.374 2.667q-.338.209-.687.422l-.615.38C6.48 21.6 6.48 21.6 6 21.6c.323-.72.68-1.22 1.24-1.774l.465-.466.502-.494.514-.512q.814-.81 1.629-1.614l1.103-1.097q1.352-1.344 2.707-2.683m3.6-3.6q.578.275 1.155.555l.65.312c.96.537.96.537 1.315 1.053.115.706.115.706 0 1.44-.483.516-.483.516-1.125.945l-.633.442c-.642.293-.642.293-1.257.28-.72-.28-1.094-.64-1.62-1.202l-.507-.534-.378-.411c.354-.828.825-1.356 1.47-1.98l.527-.514z"
    }, null, -1)
  ])]);
}
const a = { render: r };
export {
  a as default,
  r as render
};
